module.exports = __webpack_public_path__ + "img/prize-05-pic.b55ebf4b.png";